import { FulfillmentDate } from "src/components/styled/ShippingTime"
import { A } from "src/components/unstyled/A"
import { routes } from "src/config/routes"
import { StorefrontCartItem } from "src/types/storefront"
import { CartProductText } from "./CartProductText"

export type CartSummaryProductProps = {
  item: StorefrontCartItem
}

export const CartProductDetails = ({ item }: CartSummaryProductProps) => {
  const product = item.product
  const stock = item.low_stock_remaining ?? 9999
  const noStock = stock === 0
  const lowStock = stock < item.quantity
  const onBackorder = item.backorders_allowed
  const stockError = noStock ? "Leider ausverkauft" : lowStock ? `Nur noch ${stock} verfügbar` : null

  return (
    <div className="flex flex-1 flex-col justify-center gap-4">
      <div>
        <A href={routes.formatProduct(item.product.slug)} className="mr-auto">
          <CartProductText>{product.name}</CartProductText>
        </A>

        {product.variationName && <div>{product.variationName}</div>}
      </div>

      <FulfillmentDate date={product.fulfillmentFrom} />

      {!onBackorder && stockError && (
        <div className="bg-np-red mr-auto rounded-md px-4 py-2 text-white">{stockError}</div>
      )}
    </div>
  )
}
